import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export interface AiSearch {
  sourceType?: string;
  sourceId?: string;
  sourceTitle?: string;
  q?: string;
}

export const aiRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ai",
  validateSearch: (search: Record<string, unknown>): AiSearch => ({
    sourceType: typeof search["sourceType"] === "string" ? search["sourceType"] : undefined,
    sourceId: typeof search["sourceId"] === "string" ? search["sourceId"] : undefined,
    sourceTitle: typeof search["sourceTitle"] === "string" ? search["sourceTitle"] : undefined,
    q: typeof search["q"] === "string" ? search["q"] : undefined,
  }),
  component: lazyRouteComponent(() => import("./ai.page.js"), "AiPage"),
});
